import React from 'react';
import ReactDOM from 'react-dom';
import TextDisplay from './TextDisplay';

class TextSplitContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lines: []
    };
  }
  
  componentDidMount() {
    this.calculateLines();
  }
  
  componentDidUpdate(prevProps) {
    if (prevProps.text !== this.props.text || 
        prevProps.width !== this.props.width ||
        prevProps.height !== this.props.height ||
        prevProps.fontSize !== this.props.fontSize) {
      this.calculateLines();
    }
  }
  
  calculateLines = () => {
    const { text, width, fontSize } = this.props;
    const container = ReactDOM.findDOMNode(this.containerRef);
    
    // 创建测量元素
    const measurer = document.createElement('div');
    measurer.style.position = 'absolute';
    measurer.style.visibility = 'hidden';
    measurer.style.whiteSpace = 'nowrap';
    measurer.style.fontSize = `${fontSize}px`;
    document.body.appendChild(measurer);
    
    const lines = [];
    let currentLine = '';
    let remainingText = text;
    
    while (remainingText.length > 0) {
      let foundBreakPoint = false;
      currentLine = '';
      
      for (let i = 0; i < remainingText.length; i++) {
        measurer.textContent = currentLine + remainingText[i];
        
        if (measurer.offsetWidth > width) {
          foundBreakPoint = true;
          lines.push(currentLine);
          remainingText = remainingText.slice(i);
          break;
        }
        
        currentLine += remainingText[i];
      }
      
      if (!foundBreakPoint) {
        lines.push(currentLine);
        remainingText = '';
      }
    }
    
    document.body.removeChild(measurer);
    
    this.setState({ lines });
  }
  
  render() {
    return (
      <div ref={ref => this.containerRef = ref}>
        <TextDisplay 
          lines={this.state.lines}
          width={this.props.width}
          height={this.props.height}
          fontSize={this.props.fontSize}
        />
      </div>
    );
  }
}

TextSplitContainer.defaultProps = {
  text: '',
  width: 600,
  height: 50,
  fontSize: 30
};

export default TextSplitContainer;


// WEBPACK FOOTER //
// src/routes/visualChart/P45/TextSplitContainer.js